import {Component} from "./Component";
import {toPixels} from "../util/units";
import {debounce} from "../util/debounce";

const OPEN_CLASSNAME = "--open";

export class Accordion extends Component {

    static name = "accordion";
    opened = false;

    /**
     * @param {HTMLElement} el
     */
    constructor(el) {
        super(el);

        this.opened = el.classList.contains(OPEN_CLASSNAME);

        /**
         * @type {HTMLElement}
         */
        this.$el = el;

        /**
         * @type {HTMLElement}
         */
        this.$trigger = el.querySelector(".accordion__trigger");

        /**
         * @type {HTMLElement}
         */
        this.$content = el.querySelector(".accordion__content");

        this.addEventListener(this.$trigger, "click", this.onClickTrigger.bind(this));
        this.addEventListener(window, "resize", debounce(300, this.onWindowResize.bind(this)));
        this.$el[this.constructor.name] = this;

        this.updateHeight();
    }

    updateHeight() {
        this.$el.style.setProperty("--height", toPixels(this.$content.firstElementChild.offsetHeight));
    }

    onWindowResize(e) {
        console.log("onresize");
        this.updateHeight();
    }

    /**
     *
     * @param {MouseEvent} e
     */
    onClickTrigger(e) {
        console.log("onClickTrigger");
        e.preventDefault();
        this.toggle();
    }

    /**
     * Opens accordion if not already opened
     */
    open() {
        console.log("open", this.opened);
        if (this.opened) return;
        this.opened = true;
        this.$el.classList.add(OPEN_CLASSNAME);

        this.trigger("open", this);
    }

    /**
     * Closes accordion if not already closed
     */
    close() {
        console.log("close", this.opened);
        if (!this.opened) return;

        this.opened = false;
        this.$el.classList.remove(OPEN_CLASSNAME);

        this.trigger("close", this);
    }

    /**
     * Toggles accordion open
     */
    toggle() {
        if (this.opened) this.close();
        else this.open();
    }


}
